import React from 'react';
import DateTimeReportLine from './DateTimeReportLine';

// Renders one or more validity date ranges; falls back to a single from/until
// pair for legacy records without date_ranges.
const ValidityRangesText = ({ ranges, fallbackFrom, fallbackUntil }) => {
  const list = Array.isArray(ranges) && ranges.length > 0
    ? ranges.filter((r) => r && (r.from || r.until))
    : ((fallbackFrom || fallbackUntil) ? [{ from: fallbackFrom, until: fallbackUntil }] : []);
  if (list.length === 0) return null;
  const fmt = (d) => new Date(d).toLocaleDateString('de-DE');
  const rangeText = (r) => {
    if (r.from && r.until) return `${fmt(r.from)} – ${fmt(r.until)}`;
    if (r.from) return `ab ${fmt(r.from)}`;
    return `bis ${fmt(r.until)}`;
  };
  if (list.length === 1) {
    return <p style={{ margin: 'var(--spacing-1) 0', color: '#6c757d' }}>{`Die Termine gelten von ${rangeText(list[0])}.`}</p>;
  }
  return (
    <div style={{ margin: 'var(--spacing-1) 0', color: '#6c757d' }}>
      <p style={{ margin: 0 }}>Die Termine gelten in folgenden Zeiträumen:</p>
      <ul style={{ margin: '2px 0 0', paddingLeft: '1.2em' }}>
        {list.map((r, i) => <li key={i}>{rangeText(r)}</li>)}
      </ul>
    </div>
  );
};

const RECURRENCE_LABELS = {
  daily: 'Täglich',
  weekly: 'Wöchentlich',
  biweekly: 'Jeden 2. ',
  triweekly: 'Jeden 3. ',
  fourweekly: 'Jeden 4. ',
  monthly_first: 'Jeden 1. ',
  monthly_second: 'Jeden 2. ',
  monthly_third: 'Jeden 3.',
  monthly_fourth: 'Jeden 4. ',
  monthly_last: 'Jeden letzten',
};

const DAYS_DE_LONG = {
  monday: 'Montag', tuesday: 'Dienstag', wednesday: 'Mittwoch',
  thursday: 'Donnerstag', friday: 'Freitag', saturday: 'Samstag', sunday: 'Sonntag',
};

const RecurringEventsDisplay = ({ eventSchedule }) => {
  const rec = eventSchedule.recurrence || 'daily';
  const { valid_from, valid_until, date_ranges } = eventSchedule;

  const validityFromToText = (
    <ValidityRangesText ranges={date_ranges} fallbackFrom={valid_from} fallbackUntil={valid_until} />
  );

  if (rec === 'daily') {
    const times = [];
    if (eventSchedule.start_time) times.push({ start_time: eventSchedule.start_time, end_time: eventSchedule.end_time });
    (eventSchedule.additional_times || []).forEach(tp => times.push(tp));

    return (
      <div className="opening-hours-list">
        {times.map((tp, i) => (
          <DateTimeReportLine
            key={i}
            label="Täglich"
            dayData={{ opens: tp.start_time, closes: tp.end_time || '' }}
            onAdd={() => {}}
            onRemove={() => {}}
            onUpdate={() => {}}
          />
        ))}
        {validityFromToText}
      </div>
    );
  }

  // Wöchentliche und monatliche Wiederholung
  const recLabel = RECURRENCE_LABELS[rec] || rec;
  const dayLabel = eventSchedule.day_of_week ? DAYS_DE_LONG[eventSchedule.day_of_week] : null;
  const recDescription = (dayLabel ? `${recLabel} ${dayLabel}` : recLabel) + (rec.startsWith('monthly_') ? ' im Monat' : '');

  const times = [];
  if (eventSchedule.start_time) times.push({ start_time: eventSchedule.start_time, end_time: eventSchedule.end_time });
  (eventSchedule.additional_times || []).forEach(tp => times.push(tp));

  return (
    <div className="opening-hours-list">
      {times.map((tp, i) => (
        <DateTimeReportLine
          key={i}
          label={recDescription}
          dayData={{ opens: tp.start_time, closes: tp.end_time || '' }}
          onAdd={() => {}}
          onRemove={() => {}}
          onUpdate={() => {}}
        />
      ))}
      {validityFromToText}
    </div>
  );
};

export default RecurringEventsDisplay;
